<template>
  <vx-card
    id="app_body"
    class="flex-1 flex-col w-full lg:ml-base relative overflow-x-hidden"
  >
    <template slot="no-body">
      <global-header></global-header>
      <global-wrapper-list
        :loading="$apollo.queries.surat.loading"
        :loadingType="'TwoLine'"
        :loadingList="5"
        :empty="surat.data.length <= 0"
        :error="error"
        :btnShowMore="btnShowMore"
        @callbackShowMore="showMore"
      >
        <div
          class="w-full"
          v-for="(suratData, index) in suratModified"
          :key="index"
        >
          <vs-divider class="mb-0"></vs-divider>
          <div class="h5 p-3 text-grey bg-grey-100">
            {{ index | indonesian_date }}
          </div>
          <vs-divider class="mt-0"></vs-divider>
          <surat-item
            v-for="(item, key) in suratData"
            :key="key"
            :number="item.number"
            :item="item"
          />
        </div>
      </global-wrapper-list>
    </template>
  </vx-card>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";

// reusable component
import SuratItem from "./components/SuratItem.vue";

// graphql query
import { GET_ALL_FILTER, pagination } from "@/query/surat";
import { GET_ALL as ALL_BIDANG } from "@/query/bidang";

import {
  STATUS_ACCEPT,
  STATUS_CONCEPT,
  STATUS_ARCHIVE,
  STATUS_DRAFT,
  STATUS_TRASH
} from "@/const/surat";

export default {
  components: {
    SuratItem
  },
  data() {
    return {
      surat: {
        data: []
      },
      skipQuerySurat: true,
      error: false,
      paginationPage: 1,
      number: 0
    };
  },
  computed: {
    ...mapState({
      navigations: state => state.globalApp.navigations,
      search: state => state.globalApp.search
    }),

    btnShowMore() {
      return this.surat.paginatorInfo
        ? this.surat.paginatorInfo.hasMorePages
        : false;
    },
    defaultVars() {
      const { orderBy, where } = this.getCurrentNavigation().gql;
      const newWhere = { ...where, ...this.searchVars };
      return {
        perPage: pagination.perPage,
        page: this.paginationPage,
        orderBy,
        where: newWhere
      };
    },
    searchVars() {
      const query = this.search.query;
      return {
        OR: [
          {
            column: "INDEX",
            operator: "LIKE",
            value: `%${query}%`
          },
          {
            column: "PERIHAL",
            operator: "LIKE",
            value: `%${query}%`
          }
        ]
      };
    },
    filterVars() {
      return {
        ...this.defaultVars,
        filter: this.queryFilters
      };
    },
    variables() {
      return this.filterVars;
    },
    filterForms() {
      return [
        {
          label: "Bidang",
          value: "bidangId",
          component: "vs-select",
          options: this.bidang
        },
        {
          label: "Status",
          value: "status",
          component: "vs-select",
          options: [
            {
              value: STATUS_CONCEPT,
              label: "Konsep"
            },
            {
              value: STATUS_DRAFT,
              label: "Draft"
            },
            {
              value: STATUS_ACCEPT,
              label: "Acc Proses"
            },
            {
              value: STATUS_ARCHIVE,
              label: "Arsip"
            },
            {
              value: STATUS_TRASH,
              label: "Sampah"
            }
          ]
        }
      ];
    },
    isFilter() {
      try {
        const filters = this.$store.state.globalApp.filter.list;
        return filters.length;
      } catch {
        return false;
      }
    },
    queryFilters() {
      try {
        const filters = this.$store.state.globalApp.filter.list;
        return filters.reduce(
          (finalObject, filter) => ({
            ...finalObject,
            ...{
              [filter.type.value]: filter.query.value
            }
          }),
          {}
        );
      } catch {
        return {};
      }
    },
    suratModified() {
      let data = this.surat.data;

      let dataModified = data.map((d, i) => {
        return { ...d, number: i + 1 };
      });

      let group = _.groupBy(dataModified, e => e.tanggal);

      return group;
    }
  },
  apollo: {
    bidang: {
      query: ALL_BIDANG,
      variables: {
        perPage: 1000
      },
      update: data => {
        const list = data.bidang.data;
        return list.map(({ id, nama }) => ({
          value: id,
          label: nama
        }));
      },
      fetchPolicy: "cache-and-network"
    },
    surat: {
      query() {
        return GET_ALL_FILTER;
      },
      update: data => data.surat,
      error() {
        this.error = true;
      },
      skip() {
        return this.skipQuerySurat;
      },
      fetchPolicy: "network"
    }
  },
  watch: {
    "$route.params.filter"() {
      this.refreshQuerySurat();
    },
    "$route.path"() {
      this.refreshQuerySurat();
    },
    queryFilters() {
      this.refreshQuerySurat();
    },
    bidang() {
      this.$store.dispatch("globalApp/setFilterForms", this.filterForms);
    },
    search: {
      handler() {
        this.refetchQuerySurat();
      },
      deep: true
    }
  },
  created() {
    this.$store.dispatch("globalApp/emptyFilterList");
    this.$apollo.queries.surat.skip = true;
    this.refreshQuerySurat();
  },
  methods: {
    setBodyTitle() {
      const { text } = this.getCurrentNavigation();
      const title = `Surat ${text}`;
      this.$store.dispatch("globalApp/setHeaderTitle", title);
    },
    getCurrentNavigation(page = this.$route.params.filter) {
      const currentNavigation = this.navigations.list.find(
        navigation => navigation.active === page
      );

      return currentNavigation;
    },
    refreshQuerySurat() {
      this.$nextTick().then(() => {
        this.setBodyTitle();
        this.error = false;
        this.skipQuerySurat = false;
        this.paginationPage = 1;
        this.$apollo.queries.surat.setVariables({ ...this.variables });
        this.$apollo.queries.surat.refetch();
      });
    },
    refetchQuerySurat: _.debounce(function() {
      this.refreshQuerySurat();
    }, 300),
    async showMore() {
      this.paginationPage++;
      try {
        await this.$apollo.queries.surat.fetchMore({
          variables: this.variables,
          updateQuery: (previousResult, { fetchMoreResult }) => {
            const { __typename, paginatorInfo } = fetchMoreResult.surat;
            const newData = [
              ...previousResult.surat.data,
              ...fetchMoreResult.surat.data
            ];
            return {
              surat: {
                __typename: __typename,
                data: newData,
                paginatorInfo
              }
            };
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    numberIndex() {
      let num = this.number + 1;
      this.number = num;
      return num;
    }
  }
};
</script>
